import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { FaAngleLeft } from "react-icons/fa";
import axios from "axios";
import Select from "react-select";
import { Editor } from "@tinymce/tinymce-react";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Addadvisory = () => {
  const [file, setFile] = useState({
    files: "",
    preview:
      "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
  });
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countryId, setCountryID] = useState([]);
  const [data, setData] = useState([]);
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  let token = localStorage.getItem("accessToken");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const profileImage = (e) => {
    const selected = e.target.files[0];
    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      setError(false);
      setFile({
        files: e.target.files[0],
        preview: URL.createObjectURL(e.target.files[0]),
      });
    } else {
      setError(true);
    }
  };

  const handleCountry = (e) => {
    // const getCounryId = e.target.value;
    // setCountryID(getCounryId);
    setCountryID(Array.isArray(e) ? e.map((x) => x.value) : []);
  };

  useEffect(() => {
    // axios
    //   .get(process.env.REACT_APP_API + "get-country")
    //   .then((res) => setData(res.data.data))
    //   .catch((err) => console.log(err));
    getCountry();
  }, []);

  // const countries = [...new Set(data)];
  // countries.sort();

  const getCountry = async () => {
    const res = await axios({
      method: "GET",
      url: process.env.REACT_APP_API + "get-country",
    });

    const data = res?.data?.data;
    const options = data?.map((d) => ({
      value: d?.id,
      label: d?.country_name,
    }));
    setData(options);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    let formData = new FormData();

    formData.append("firstname", data?.firstname);
    formData.append("lastname", data?.lastname);
    formData.append("email", data?.email);
    formData.append("profile_designation", data?.profile_designation);
    formData.append("website_url", data?.website_url);
    formData.append("twitter_url", data?.twitter_url);
    formData.append("linkedIn_url", data?.linkedIn_url);
    formData.append("youTube_url", data?.youTube_url);
    formData.append("profile_pic", file?.files);
    formData.append("country_id", JSON.stringify(countryId));
    formData.append("about_profile", description);

    try {
      const res = await axios({
        method: "POST",
        url: process.env.REACT_APP_API + "save-our-advisory",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      });

      if (res.data.status === 200) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/advisory-board");
      }
    } catch (error) {
      setLoading(false);
      if (error.response !== "" && error.response.data.message !== "") {
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Add New Advisory Board</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <div className="imgChange-div">
                <img src={ImgChangeIcon} alt="" className="imgChangeIcon" />
              </div>
              <input
                type="file"
                name="file"
                accept="image/png , image/jpeg"
                title=""
                className="profile-pic-select"
                onChange={(e) => profileImage(e)}
              />

              <img
                src={
                  file
                    ? file.preview
                    : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                }
                alt=""
                className="setting-profile"
              />
            </div>

            {error && (
              <span style={{ color: "red" }}>
                Please upload file in jpg,jpeg and png format
              </span>
            )}
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  {...register("firstname", {
                    required: "First name is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter First Name"
                />
                {errors.firstname && (
                  <div className="invalid-feedback">
                    {errors.firstname.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  {...register("lastname", {
                    required: "Last name is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Last Name"
                />
                {errors.lastname && (
                  <div className="invalid-feedback">
                    {errors.lastname.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value:
                        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                      message: "Please enter a valid email address",
                    },
                  })}
                  placeholder="Enter Email"
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email.message}</div>
                )}
              </div>
              <div className="formInput">
                <label>Profession</label>

                <select
                  name="profile_designation"
                  {...register("profile_designation", {
                    required: "Profession is required",
                  })}
                >
                  <option value="" disabled selected hidden>
                    Select Profession
                  </option>
                  <option value="accountants">Accountants</option>
                  <option value="lawyers">Lawyers</option>
                  <option value="consulting Company">Consulting company</option>
                </select>
                {errors.profile_designation && (
                  <div className="invalid-feedback">
                    {errors.profile_designation.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Country</label>
                {/* <select
                  name="country"
                  className="sort-by dropdown"
                  {...register("country", {
                    required: "Country is required",
                  })}
                  onChange={(e) => handleCountry(e)}
                  value={countryId}
                >
                  <option value="" disabled selected hidden>
                    Select Country
                  </option>
                  {countries.map((items) => (
                    <option key={items.id} value={items.id}>
                      {items.country_name}
                    </option>
                  ))}
                </select> */}
                <Select
                  className="sort-by dropdown country-drp"
                  isMulti={true}
                  options={data}
                  value={countryId?.map(
                    (id) => data?.filter((d) => d.value == id)[0]
                  )}
                  onChange={handleCountry}
                />
              </div>
              <div className="formInput">
                <label>Website</label>
                <input
                  type="text"
                  name="website_url"
                  {...register("website_url", {
                    pattern: {
                      value:
                        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Website"
                />
                {errors.website_url && (
                  <div className="invalid-feedback">
                    {errors.website_url.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Twitter</label>
                <input
                  type="text"
                  name="twitter_url"
                  {...register("twitter_url", {
                    pattern: {
                      value:
                        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Twitter"
                />
                {errors.twitter_url && (
                  <div className="invalid-feedback">
                    {errors.twitter_url.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Linkedin</label>
                <input
                  type="text"
                  name="linkedIn_url"
                  {...register("linkedIn_url", {
                    pattern: {
                      value:
                        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Linkedin"
                />
                {errors.linkedIn_url && (
                  <div className="invalid-feedback">
                    {errors.linkedIn_url.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Youtube</label>
                <input
                  type="text"
                  name="youTube_url"
                  {...register("youTube_url", {
                    pattern: {
                      value:
                        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Youtube"
                />
                {errors.youTube_url && (
                  <div className="invalid-feedback">
                    {errors.youTube_url.message}
                  </div>
                )}
              </div>
              <div className="formInput"></div>
              <div className="formInputDescription">
                <label>Description</label>

                <Editor
                  initialValue="<p>This is the initial content of the editor.</p>"
                  apiKey="4xerbueqmh9h3gt7gkvu7xnlqgntlyv3qlqtcx6kr7du2cl2"
                  init={{
                    selector: "textarea",
                    height: 300,
                    menubar: true,
                    toolbar: "bottom",
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                      "lists",
                    ],
                    toolbar:
                      "undo redo | formatselect | " +
                      "bold italic backcolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                  onEditorChange={(newText) => setDescription(newText)}
                />
                {errors.about_profile && (
                  <div className="invalid-feedback text-left">
                    {errors.about_profile.message}
                  </div>
                )}
              </div>

              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addadvisory;
